import React from 'react';
import * as Icons from 'react-icons/fa';

const Icon = ({ icon, size }) => {
	const Ic = Icons[icon];
	return <Ic size={size || 20} />;
};

export default Icon;
